<template>
  <div class="animated fadeIn">
    <div class="dashboard-header d-flex justify-content-end mb-3">
      <display-mode-toggle
        v-if="canViewCharts || canViewMetrics"
        v-model="displayMode"
        storage-key="dashboard:displayMode:ombudsman"
      />
    </div>
    <status-metrics
      v-if="canViewMetrics"
      :status-data="statusData || []"
      :labels="ombudsmanLabels"
    ></status-metrics>

    <list-notifications
      :company="company._id"
      type="ombudsman"
    ></list-notifications>

    <b-row v-if="isMasterUser || isOperationalUser" class="mb-4">
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <overdue-ombudsman :company-id="company._id"></overdue-ombudsman>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="canViewCharts">
      <b-col sm="6" lg="4">
        <b-card no-body class="chart-card chart-animation">
          <b-card-body>
            <status-chart
              :company="company._id"
              type="ombudsman"
              title="Qtd. Solicitações x Situação"
              :style="{ 'max-height': maxHeight }"
            ></status-chart>
          </b-card-body>
        </b-card>
      </b-col>
      <template v-if="company.classification">
        <b-col
          v-if="company.classification.receivingMeans.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Meio Recebimento"
                type="ombudsman"
                classification="receivingMeans"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.involvedDepartment.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Setor da Ocorrência"
                type="ombudsman"
                classification="involvedDepartment"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col v-if="company.classification.businessUnit.enabled" sm="6" lg="4">
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Unidade Reclamada"
                type="ombudsman"
                classification="businessUnit"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.ombudsmanNature.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Natureza"
                type="ombudsman"
                classification="ombudsmanNature"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.ombudsmanService.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Serviço"
                type="ombudsman"
                classification="ombudsmanService"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.ombudsmanSegment.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Segmento"
                type="ombudsman"
                classification="ombudsmanSegment"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.ombudsmanClosure.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <classification-chart
                :company="company._id"
                title="Qtd. Solicitações x Indicador de Encerramento"
                type="ombudsman"
                classification="ombudsmanClosure"
                :style="{ 'max-height': maxHeight }"
              >
              </classification-chart>
            </b-card-body>
          </b-card>
        </b-col>
      </template>
      <b-col sm="6" lg="4">
        <b-card no-body class="chart-card chart-animation">
          <b-card-body>
            <ombudsman-time-box-plot
              :company="company._id"
            ></ombudsman-time-box-plot>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ListNotifications from "../list-notifications";
import OmbudsmanTimeBoxPlot from "../charts/ombudsman/OmbudsmanTimeBoxPlot";
import OverdueOmbudsman from "../charts/ombudsman/OverdueOmbudsman";
import ClassificationChart from "../charts/ClassificationChart";
import StatusChart from "../charts/StatusChart";
import { companyStatusChart } from "../../../api/charts";
import StatusMetrics from "../StatusMetrics";
import DisplayModeToggle from "../DisplayModeToggle.vue";

const STORAGE_KEY = "dashboard:displayMode:ombudsman";

export default {
  name: "OmbudsmanDashboard",
  components: {
    ClassificationChart,
    StatusChart,
    ListNotifications,
    OmbudsmanTimeBoxPlot,
    OverdueOmbudsman,
    StatusMetrics,
    DisplayModeToggle,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
    filterCompanyId: {
      type: [Number, String],
      default: null,
    },
  },
  provide() {
    return {
      dashboardDisplayMode: this.dashboardDisplayMode,
    };
  },
  data() {
    const stored = localStorage.getItem(STORAGE_KEY);
    const initialMode = stored === "percent" ? "percent" : "absolute";
    return {
      maxHeight: "100%",
      statusData: [],
      ombudsmanLabels: {
        total: "TOTAL SOLICITAÇÕES",
        new: "NOVAS",
        processing: "EM PROCESSAMENTO",
        concluded: "CONCLUÍDAS",
      },
      displayMode: initialMode,
      dashboardDisplayMode: Vue.observable({ mode: initialMode }),
    };
  },
  watch: {
    filterCompanyId: {
      immediate: true,
      handler() {
        this.loadDashboardData();
      },
    },
    "company._id": {
      handler(newVal) {
        if (newVal && !this.filterCompanyId) {
          this.loadDashboardData();
        }
      },
    },
    displayMode(newMode) {
      this.dashboardDisplayMode.mode = newMode;
    },
  },
  computed: {
    ...mapGetters(["profile", "permissions"]),
    isMasterUser() {
      return (
        this.profile.role === "root" || this.profile.role === "company-root"
      );
    },
    isWhitelabel() {
      return this.$route.meta && this.$route.meta.whitelabel;
    },
    canViewMetrics() {
      // Root, Master (company-root) e Master with Whitelabel
      return (
        this.profile.role === "root" || this.profile.role === "company-root"
      );
    },
    isOperationalUser() {
      return typeof this.profile.role === "number";
    },
    canViewCharts() {
      if (parseInt(this.profile.role) === this.profile.role) {
        return this.permissions.ombudsman && this.permissions.ombudsman.read;
      }
      return true;
    },
  },
  methods: {
    async loadDashboardData() {
      try {
        const companyId =
          this.filterCompanyId ||
          (this.isMasterUser ? null : this.profile.company);
        const response = await companyStatusChart(companyId, "ombudsman");
        this.statusData = response.data;
      } catch (error) {
        console.error("Error fetching ombudsman status data:", error);
      }
    },
  },
};
</script>
